import React, { useRef, useState, useEffect } from "react"

// redux
import { useNavigate } from "react-router-dom"
import { mapDispatchProps, mapStateToProps } from "../../../store/store"
import { connect } from "react-redux"
import Button from "../../../components/button"
import { Modal } from "antd"
import Label from "../../../components/label"
import { ROUTES } from "../../../routes"
import API from "../../../api"
import dayjs from "dayjs"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { useLanguage } from "@languages/index"
import ModalRentalDiscontinued from "components/modalRentalDiscontinued"

const RentalIndex = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }
  const navigate = useNavigate()
  const [isGuideModalVisible, setIsGuideModalVisible] = useState(false)

  useEffect(() => {
    fetchBrand()
  }, [])

  useEffect(() => {
    showGuideModal()
  }, [])

  useEffect(() => {
    props.showModal({
      content: () => {
        return (
          <ModalRentalDiscontinued closeModal={props.closeModal} />
        );
      },
    });
  }, []);

  const navigateWithScroll = (routePath, topOffset = 0) => {
    const scrollToOptions = { top: topOffset, left: 0, behavior: "instant" }
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions) // Temporary solved Typescript bug (https://github.com/microsoft/TypeScript/issues/47441)
    navigate(routePath)
  }

  const showGuideModal = () => {
    if ([languageTexts.index_text_1].includes(props.brand.name)) return false

    if (
      props.brand.hasExperiencedProductCreate &&
      props.brand.hasExperiencedProductSend &&
      props.brand.hasExperiencedCardCreate
    ) {
      return false
    }

    setIsGuideModalVisible(true)
  }

  const fetchBrand = async () => {
    await API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        props.setBrand(response.data.brand)

        if (response.data.brand.hasExperiencedSnsInstall && !response.data.brand.snsPassInstalledAt) {
          navigateWithScroll(ROUTES.SNS_PAYMENT_COMPLETE.PATH)
        }
      })
      .catch((error) => {
        props.showModal({
          text: languageTexts.index_text_2,
        })
      })
  }

  const updateBrand = async (config?: any) => {
    const params = {}
    if (config.hasExperiencedProductCreate) {
      params["hasExperiencedProductCreate"] = config.hasExperiencedProductCreate
    }

    if (config.hasExperiencedProductSend) {
      params["hasExperiencedProductSend"] = config.hasExperiencedProductSend
    }

    if (config.hasExperiencedCardCreate) {
      params["hasExperiencedCardCreate"] = config.hasExperiencedCardCreate
    }

    await API.Brand.update({
      brandToken: props.auth.token,
      ...params,
    })
      .then((response) => {
        let arr = {
          text: response.data.message,
        }

        props.showModal(arr)
      })
      .catch((error) => {
        props.setPopup({
          isVisible: true,
          text: error.message,
        })
      })
  }

  const goals = [
    {
      title: languageTexts.index_text_3,
      btnText: languageTexts.index_text_4,
      value: props.brand.hasExperiencedProductCreate,
      onSubmit: () => {
        navigateWithScroll(ROUTES.PRODUCT_INDEX.PATH)
      },
    },
    {
      title: languageTexts.index_text_5,
      btnText: languageTexts.index_text_6,
      description: languageTexts.index_text_7,
      copy: true,
      value: props.brand.hasExperiencedProductSend,
      onSubmit: async () => {
        await updateBrand({
          hasExperiencedProductSend: true,
        })

        await fetchBrand()
      },
    },
    {
      title: languageTexts.index_text_8,
      btnText: languageTexts.index_text_9,
      value: props.brand.hasExperiencedCardCreate,
      onSubmit: () => {
        navigateWithScroll(ROUTES.CARD_INDEX.PATH)
      },
    },
  ]

  const currentMonth = dayjs().format("MM")
  const nextMonth = dayjs().add(1, "month").format("MM")

  const decodeRentableUserTypes = (rentableUserTypes) => {
    let has_common = false
    let has_ambassador = false
    if (rentableUserTypes.indexOf(languageTexts.index_text_10) >= 0) has_common = true
    if (rentableUserTypes.indexOf(languageTexts.index_text_11) >= 0) has_ambassador = true

    if (!has_common && !has_ambassador) return languageTexts.index_text_12
    if (has_common && !has_ambassador) return languageTexts.index_text_13
    if (!has_common && has_ambassador) return languageTexts.index_text_14
    return languageTexts.index_text_15
  }

  const openRentalDiscontinuedModal = () => {
    props.showModal({
      content: () => (
        <ModalRentalDiscontinued closeModal={props.closeModal} />
      )
    })
  }

  return (
    <div
      className="w-full flex flex-col items-center justify-center"
      style={{ paddingTop: props.preferences.headerHeight }}
    >
      <div className="flex flex-col w-full mx-auto max-w-[1024px]">
        <div className="flex flex-col py-[80px] mx-auto">
          <span className="text-center text-[36px] font-bold">{languageTexts.index_text_16}</span>
        </div>

        <div>
          <Button
            onClick={() => {
              openRentalDiscontinuedModal()
            }}
            className="bg-[#FF0000]"
            renderChildren={() => (
              <div className="py-[20px] px-[24px] w-full flex flex-row justify-between font-bold text-white">
                <div>2025년 9월 26일부로 제품 대여 서비스를 종료합니다.</div>
                <div>자세히 보기 →</div>
              </div>
            )}
          />
        </div>

        <div className="mt-[10px] grid grid-cols-1 md:grid-cols-2 gap-[20px] mb-[100px] w-full">
          {/* First Card */}
          <div className="section-products rounded-[10px] border border-gray-200 p-[30px] flex flex-col">
            <div className="flex flex-row justify-between">
              <span className="text-[22px] font-bold">{languageTexts.index_text_17}</span>
            </div>

            <div className="flex flex-col mt-[28px] mb-[30px] gap-[15px]">
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts.index_text_18}</span>
                <span className="text-[15px] text-indigo-500 font-bold">
                  {languageTexts._amount(props.brand.productsInRentableCount)}
                </span>
              </div>
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts.index_text_19}</span>
                <span className="text-[15px] text-indigo-500 font-bold">
                  {languageTexts._amount(props.brand.productsInInspectionCount)}
                </span>
              </div>
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts.index_text_20}</span>
                <span className="text-[15px] text-indigo-500 font-bold">
                  {languageTexts._amount(props.brand.productsInReturningCount)}
                </span>
              </div>
            </div>

            <div className="flex flex-col mt-auto">
              <Button
                text={languageTexts.show_detail}
                className="rounded-[5px] py-[15px] text-center"
                onClick={() => {
                  openRentalDiscontinuedModal()
                  navigateWithScroll(ROUTES.PRODUCT_INDEX.PATH)
                }}
              />
            </div>
          </div>

          {/* Second Card */}
          <div className="section-payments rounded-[10px] border border-gray-200 p-[30px] flex flex-col">
            <div className="">
              <span className="text-[22px] font-bold">{languageTexts.index_text_21}</span>
            </div>

            <div className="flex flex-col mt-[28px] mb-[30px] gap-[15px]">
              <div className="flex flex-row w-full justify-between items-center">
                <div className="flex flex-col">
                  <span className="text-[15px]">{languageTexts.index_text_22}</span>
                  <span className="text-[13px] text-[#999999] mt-[5px]">{languageTexts.index_text_23}</span>
                </div>
                <div className="flex flex-col text-right">
                  <span className="text-[15px] text-indigo-500 font-bold">
                    {props.brand.maxBudgetRental >= 1500000000 ? (
                      languageTexts.unlimited
                    ) : (
                      <>
                        {languageTexts._price(
                          props.brand.maxBudgetRental ? parseInt(props.brand.maxBudgetRental).toLocaleString() : 0,
                          props.settings.currencyText
                        )}
                      </>
                    )}
                  </span>
                  <span className="ml-auto text-[13px] text-[#999999]">{languageTexts.index_text_24}</span>
                </div>
              </div>
              <div className="flex flex-row w-full justify-between items-center">
                <div className="flex flex-col">
                  <span className="text-[15px]">{languageTexts._index_text_25(currentMonth)}</span>
                  <span className="text-[13px] text-[#999999] mt-[5px]">
                    {languageTexts._index_text_26(currentMonth, nextMonth)}
                  </span>
                </div>
                <div className="flex flex-col text-right">
                  <span className="text-[15px] text-indigo-500 font-bold">
                    {languageTexts._price(
                      props.brand.billingAmountThisMonth
                        ? parseInt(props.brand.billingAmountThisMonth).toLocaleString()
                        : 0,
                      props.settings.currencyText
                    )}
                  </span>
                  <span className="ml-auto text-[13px] text-[#999999]">{languageTexts.index_text_27}</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col mt-auto">
              <Button
                text={languageTexts.show_detail}
                className="rounded-[5px] py-[15px] text-center"
                onClick={() => {
                  openRentalDiscontinuedModal()
                  navigateWithScroll(ROUTES.RENTAL_PAYMENTS_INDEX.PATH)
                }}
              />
            </div>
          </div>

          {/* Third Card */}
          <div className="section-payments rounded-[10px] border border-gray-200 p-[30px] flex flex-col">
            <div className="">
              <span className="text-[22px] font-bold">{languageTexts.index_text_28}</span>
            </div>

            <div className="flex flex-col mt-[28px] mb-[30px] gap-[15px]">
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts.index_text_29}</span>
                <span className="text-[15px] text-indigo-500 font-bold">
                  {decodeRentableUserTypes(props.brand.rentableUserTypes)}
                </span>
              </div>
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts.index_text_31}</span>
                <span className="text-[15px] text-indigo-500 font-bold">
                  {props.brand.maxRentalLimitAmbassador >= 9999
                    ? languageTexts.unlimited
                    : languageTexts._clothes(
                        props.brand.maxRentalLimitAmbassador ? props.brand.maxRentalLimitAmbassador.toLocaleString() : 0
                      )}
                </span>
              </div>
            </div>

            <div className="flex flex-col mt-auto">
              <Button
                text={languageTexts.show_detail}
                className="rounded-[5px] py-[15px] text-center"
                onClick={() => {
                  openRentalDiscontinuedModal()
                  navigateWithScroll(ROUTES.RENTAL_AMBASSADOR_INDEX.PATH)
                }}
              />
            </div>
          </div>

          {/* Fourth Card */}
          <div className="section-payments rounded-[10px] border border-gray-200 p-[30px] flex flex-col">
            <div className="">
              <span className="text-[22px] font-bold">{languageTexts.index_text_32}</span>
            </div>

            <div className="flex flex-col mt-[28px] mb-[30px] gap-[15px]">
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts._index_text_33(currentMonth)}</span>
                <div className="flex flex-col text-right">
                  <span className="text-[15px] text-indigo-500 font-bold">
                    {languageTexts._amount(
                      props.brand.billingCompletedCountThisMonth
                        ? props.brand.billingCompletedCountThisMonth.toLocaleString()
                        : 0
                    )}
                  </span>

                  <span className="text-[13px] text-[#999999] mt-[5px]">
                    {languageTexts._index_text_34(props.brand.billingCompletedCountAmbassadorThisMonth)}
                    {` + `}
                    {languageTexts._index_text_35(props.brand.billingCompletedCountNormalThisMonth)}
                  </span>
                </div>
              </div>
              <div className="flex flex-row w-full justify-between">
                <span className="text-[15px]">{languageTexts._index_text_36(currentMonth)}</span>

                <div className="flex flex-col text-right">
                  <span className="text-[15px] text-indigo-500 font-bold">
                    {languageTexts._amount(
                      props.brand.billingCreatingCountThisMonth
                        ? props.brand.billingCreatingCountThisMonth.toLocaleString()
                        : 0
                    )}
                  </span>

                  <span className="text-[13px] text-[#999999] mt-[5px]">
                    {languageTexts._index_text_34(props.brand.billingCreatingCountAmbassadorThisMonth)}
                    {` + `}
                    {languageTexts._index_text_35(props.brand.billingCreatingCountNormalThisMonth)}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col mt-auto">
              <Button
                text={languageTexts.show_detail}
                className="rounded-[5px] py-[15px] text-center"
                onClick={() => {
                  openRentalDiscontinuedModal()
                  navigateWithScroll(ROUTES.POSTING_INDEX.PATH)
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <GuideMdal
        {...props}
        goals={goals}
        isGuideModalVisible={isGuideModalVisible}
        onOk={() => {
          setIsGuideModalVisible(false)
        }}
        {...props}
      />
    </div>
  )
}

const GuideGoal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }
  return (
    <div className="flx flex-col">
      <div className="flex flex-row gap-[10px] items-center">
        <span className="text-[15px] font-bold">{props.goal.title}</span>
        <Label
          text={props.goal.value ? languageTexts.done : languageTexts.notdone}
          labelColor={props.goal.value ? "#D9F4CF" : "#FFCCCC"}
          textColor={props.goal.value ? "#1DCD00" : "#FF0000"}
          className="px-[8px] max-h-[20px]"
          textClassName="text-[11px] font-bold my-auto"
        />
      </div>
      {props.goal.description ? (
        <>
          <div className="h-[10px]" />
          <div className="flex flex-row w-full gap-[10px]">
            <span className="text-[15px]">{props.goal.description}</span>

            {props.goal.copy ? (
              <CopyToClipboard
                onCopy={(copied, result) => {
                  let title = languageTexts.index_text_37
                  let text = languageTexts.index_text_38
                  if (!result) {
                    title = languageTexts.index_text_39
                    text = languageTexts.index_text_40
                  }

                  props.showModal({ title: title, text: text })
                }}
                text={`${props.goal.description}`}
              >
                <div className="ml-6 cursor-pointer underline font-bold text-[#999999]">
                  {languageTexts.index_text_41}
                </div>
              </CopyToClipboard>
            ) : null}
          </div>
        </>
      ) : null}
      {props.goal.value ? null : (
        <>
          <div className="h-[10px]" />
          <div className="flex flex-row w-full">
            <Button
              text={props.goal.btnText}
              className="flex w-full text-center justify-center py-[15px]"
              textColor={"WHITE"}
              buttonColor={"BLACK"}
              onClick={() => {
                props.goal.onSubmit ? props.goal.onSubmit() : null
              }}
            />
          </div>
        </>
      )}
    </div>
  )
}

const GuideMdal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }
  return (
    <Modal centered={true} open={props.isGuideModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[30px] sm:px-[30px] sm:py-[26px]">
        <div className="title">
          <span className="text-[22px] font-bold">{languageTexts._index_text_42()}</span>
        </div>

        <div className="content flex flex-col gap-[30px]">
          {props.goals.map((goal, idx) => {
            return <GuideGoal key={idx} {...props} goal={goal} />
          })}
        </div>

        <div />
      </div>

      <div className="w-full flex flex-col sm:pb-[26px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(RentalIndex)
